module.exports = __webpack_public_path__ + "bh.c47c4db1.svg";